const root = '/files';
const results = `${root}/results`;
const stoneImages = resultId => `validate/${resultId}`;

export const filesEndpoints = {
  root,
  results,
  stoneImages
};
